import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDashboards } from "../../store/slices/admin/dashboards";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "../admin/icons";
import { resetStoreState } from "../../store/slices/resetStore";


import Select from "react-select";

type DashboardNavigationProps = {
    theme: string
}

const DashboardNavigation = ({theme} : DashboardNavigationProps) => {
    const { id } = useParams() as any;
    const dispatch = useDispatch();
    const history = useHistory();
    const [fetchedListOfDashboards, setFetchedListOfDashboards] = useState(false)

    const dashboards = useSelector((state : any) => state.dashboards.data);
    const dashboardsLoading = useSelector((state: any) => state.dashboards.isLoading);

    const singleDashboardLoading = useSelector((state : any) => state.dashboard.isLoading);
    const gridLoading = useSelector((state : any) => state.grids.isLoading);
    const storyListLoading = useSelector((state : any) => state.storylist.isLoading);
    const videoListLoading = useSelector((state : any) => state.videolist.isLoading);
    const brandSettingsLoading = useSelector((state : any) => state.brandsettings.isLoading);

    const [selectedDashboard, setSelectedDashboard] = useState({value: "", label: ""});
    const [prevDashboard, setPrevDashboard] = useState({value: "", label: ""})
    const [nextDashboard, setNextDashboard] = useState({value: "", label: ""})

    useEffect(()=>{
        if (brandSettingsLoading) return;
        if (!fetchedListOfDashboards) {
            dispatch(fetchDashboards(null as any, 2000));
            setFetchedListOfDashboards(true);
        }
    },[dispatch, setFetchedListOfDashboards, fetchedListOfDashboards, brandSettingsLoading]);


    useEffect(()=>{
        if (dashboards.length > 0) {
            const foundDashboard = dashboards.find((dashboard : any) => dashboard.id === id);
            const foundIndex = dashboards.findIndex((dashboard : any) => dashboard.id === id);
            
            if (!foundDashboard) {
                setSelectedDashboard({
                    value: "",
                    label: ""
                });
                return
            }

            setSelectedDashboard({
                value: foundDashboard.id,
                label: foundDashboard.description
            });
            if (foundIndex <= dashboards.length - 2) {
                setNextDashboard({
                    value: dashboards[foundIndex + 1].id,
                    label: dashboards[foundIndex + 1].description
                })
            } else {
                setNextDashboard({
                    value: dashboards[0].id,
                    label: dashboards[0].description
                })
            }
            if (foundIndex > 0) {
                setPrevDashboard({
                    value: dashboards[foundIndex - 1].id,
                    label: dashboards[foundIndex - 1].description
                })
            } else {
                setPrevDashboard({
                    value: dashboards[dashboards.length - 1].id,
                    label: dashboards[dashboards.length - 1].description
                })
            }
        }
    },[dashboards, id])


    const isDashboardDataLoading = useMemo(()=>{
        return singleDashboardLoading || gridLoading || storyListLoading || videoListLoading
    },[singleDashboardLoading, gridLoading, storyListLoading, videoListLoading])

    const dashboardOptions = useMemo(()=>{
        return dashboards.map((dashboard : any) => {
            return {
                value: dashboard.id,
                label: dashboard.description
            }
        })
    },[dashboards])

    const changeDashboard = (option : string) => {
            history.push(`/dashboards/${option}`);
    }

    const handleChange = (option: any) => {
        dispatch(resetStoreState());
        setSelectedDashboard(option); 
        changeDashboard(option);
    };

    const calculateArrowsColor = useMemo(()=>{
        if (theme === "light") return "black";
        return "hsl(0,0%,80%)";
    },[theme])

    return <>
        <div className="dashboard-navigation-wrapper" >
            <div className="dashboard-navigation-container">
                <Select
                    id="dashboardSelect"
                    className={"select-dashboard-container"}
                    classNamePrefix={"select-dashboard"}
                    isSearchable={true}
                    isLoading={dashboardsLoading}
                    value={dashboardOptions.find((dashboard: any) => dashboard.value === selectedDashboard.value)}
                    options={dashboardOptions}
                    onChange={(option: any) => handleChange(option!.value)}
                    menuPortalTarget={document.body}
                    styles={{menuPortal: base => ({...base, zIndex: 9999})}}
                />
            </div>  
            
                <>
                    <div className={["prev-dashboard-button", `${isDashboardDataLoading ? "disabled" : ""}`].join(" ")}  
                        onClick={()=>{
                            if (!isDashboardDataLoading) {
                                handleChange(prevDashboard.value)}
                            }
                        }>
                        <ArrowLeft color={calculateArrowsColor}/>
                    </div>
                    <div className={["prev-dashboard-button", `${isDashboardDataLoading ? "disabled" : ""}`].join(" ")} 
                        onClick={()=>{
                            if (!isDashboardDataLoading) {

                                handleChange(nextDashboard.value)
                            }
                        }
                            }>
                        <ArrowRight color={calculateArrowsColor}/>
                    </div>
                  
                </> 
        </div>
    </>
}


export default DashboardNavigation;